import { render } from "./MenuAnnouncement.vue?vue&type=template&id=7f6132dd&scoped=true"
import script from "./MenuAnnouncement.vue?vue&type=script&lang=js"
export * from "./MenuAnnouncement.vue?vue&type=script&lang=js"

import "./MenuAnnouncement.vue?vue&type=style&index=0&id=7f6132dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6132dd"]])

export default __exports__